import { Link } from 'react-router-dom'

const diferenciais = [
  {
    icon: 'fa-cash-register',
    titulo: 'PDV Ágil',
    desc: 'Frente de caixa rápida com leitura de código de barras e múltiplas formas de pagamento.',
  },
  {
    icon: 'fa-boxes-stacked',
    titulo: 'Estoque Diversificado',
    desc: 'Gestão de centenas de itens com controle de mínimo e reposição automática.',
  },
  {
    icon: 'fa-hand-holding-dollar',
    titulo: 'Crediário e Recebíveis',
    desc: 'Controle de vendas a prazo, carnê de clientes e gestão de contas a receber.',
  },
  {
    icon: 'fa-file-invoice',
    titulo: 'Emissão Fiscal',
    desc: 'Emissão de NF-e e NFC-e integrada, com transmissão automática para a SEFAZ.',
  },
]

const secoes = [
  {
    titulo: 'Vendas e PDV',
    img: '/img/solucoes/papelaria/papelaria.jpg',
    items: [
      'PDV rápido com leitura de código de barras e pesquisa por descrição',
      'Múltiplas formas de pagamento: dinheiro, cartão, PIX, crediário',
      'Controle de crediário e carnê por cliente',
      'Desconto por item ou por total da venda',
      'Sangria, suprimento e fechamento de caixa por operador',
      'Histórico completo de compras por cliente',
    ],
    cta: { label: 'Agendar Demonstração', href: '/agendar-visita' },
    imgEsquerda: true,
  },
  {
    titulo: 'Estoque e Compras',
    img: '/img/solucoes/papelaria/estoque.jpg',
    items: [
      'Cadastro de produtos com código de barras e unidade de medida',
      'Controle de estoque de itens diversificados (papéis, tintas, materiais escolares)',
      'Entrada de mercadorias via nota fiscal do fornecedor',
      'Alertas de estoque mínimo por produto',
      'Sugestão de compra automática com base no consumo',
      'Inventário periódico com ajuste automático',
    ],
    cta: { label: 'Agendar Demonstração', href: '/agendar-visita' },
    imgEsquerda: false,
  },
  {
    titulo: 'Fiscal',
    img: '/img/solucoes/entrada.webp',
    items: [
      'Emissão de NFC-e (cupom fiscal eletrônico) no caixa',
      'Emissão de NF-e para vendas a pessoa jurídica',
      'Cancelamento e inutilização de documentos fiscais',
      'Transmissão automática para a SEFAZ',
      'Relatórios fiscais prontos para o contador',
    ],
    cta: { label: 'Falar com um Consultor', href: '/agendar-visita' },
    imgEsquerda: true,
  },
]

export default function SolucaoPapelaria() {
  return (
    <>
      {/* Hero */}
      <section
        className="relative bg-quantum-blue py-20 text-white bg-cover bg-center"
        style={{ backgroundImage: "url('/img/contabilidade.jpg')" }}
      >
        <div className="absolute inset-0 bg-quantum-blue/80" />
        <div className="relative max-w-7xl mx-auto px-4">
          <div className="max-w-2xl">
            <p className="text-quantum-red font-semibold uppercase tracking-widest text-sm mb-3">
              Solução para Papelaria
            </p>
            <h1 className="text-4xl md:text-5xl font-bold leading-tight mb-6">
              Sistema completo para a sua papelaria
            </h1>
            <p className="text-blue-200 text-lg mb-8">
              Do PDV ao controle de estoque diversificado, do crediário à emissão fiscal — o Quantum
              foi desenvolvido para a rotina dinâmica das papelarias.
            </p>
            <div className="flex flex-wrap gap-4">
              <Link
                to="/agendar-visita"
                className="bg-quantum-red hover:bg-red-700 text-white font-bold px-8 py-4 rounded-lg transition-colors"
              >
                Agendar Demonstração
              </Link>
              <Link
                to="/solucoes"
                className="border border-white/40 hover:border-white text-white font-semibold px-8 py-4 rounded-lg transition-colors"
              >
                Ver outras soluções
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Diferenciais */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4">
          <h2 className="text-2xl font-bold text-quantum-blue text-center mb-10">
            Por que escolher o Quantum para a sua papelaria?
          </h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {diferenciais.map(({ icon, titulo, desc }) => (
              <div key={titulo} className="bg-white rounded-xl p-6 shadow-sm border border-gray-100 text-center">
                <div className="w-14 h-14 bg-blue-50 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className={`fa-solid ${icon} text-quantum-blue text-xl`} />
                </div>
                <h3 className="font-bold text-quantum-blue mb-2">{titulo}</h3>
                <p className="text-gray-500 text-sm leading-relaxed">{desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Seções de funcionalidades */}
      {secoes.map(({ titulo, img, items, cta, imgEsquerda }, idx) => (
        <section key={titulo} className={`py-16 ${idx % 2 === 0 ? 'bg-gray-50' : 'bg-white'}`}>
          <div className="max-w-6xl mx-auto px-4">
            <div className={`flex flex-col ${imgEsquerda ? 'lg:flex-row' : 'lg:flex-row-reverse'} gap-10 items-center`}>
              <div className="w-full lg:w-1/2 flex-shrink-0">
                <img src={img} alt={titulo} className="w-full h-72 object-cover rounded-2xl shadow-md" />
              </div>
              <div className="w-full lg:w-1/2">
                <h2 className="text-2xl font-bold text-quantum-blue mb-6">{titulo}</h2>
                <ul className="space-y-3 mb-8">
                  {items.map((item) => (
                    <li key={item} className="flex items-start gap-3 text-gray-700 text-sm">
                      <i className="fa-solid fa-check text-quantum-blue mt-0.5 flex-shrink-0" />
                      {item}
                    </li>
                  ))}
                </ul>
                <Link
                  to={cta.href}
                  className="inline-block bg-quantum-blue hover:bg-quantum-blue-dark text-white font-bold px-7 py-3 rounded-lg transition-colors text-sm"
                >
                  {cta.label}
                </Link>
              </div>
            </div>
          </div>
        </section>
      ))}

      {/* CTA final */}
      <section className="py-16 bg-quantum-blue text-white text-center">
        <div className="max-w-3xl mx-auto px-4">
          <h2 className="text-3xl font-bold mb-4">Pronto para modernizar sua papelaria?</h2>
          <p className="text-blue-200 mb-8">
            Fale com nosso time e agende uma demonstração sem compromisso.
          </p>
          <Link
            to="/agendar-visita"
            className="inline-block bg-quantum-red hover:bg-red-700 text-white font-bold px-10 py-4 rounded-lg transition-colors"
          >
            Agendar Demonstração Gratuita
          </Link>
        </div>
      </section>
    </>
  )
}
